export const FETCH_POPULAR_SKILLS_SUCCESS = 'FETCH_POPULAR_SKILLS_SUCCESS';
export const FETCH_POPULAR_SKILLS_FAILURE= 'FETCH_POPULAR_SKILLS_FAILURE';
